import React from 'react';

// Admin Imports
import MainDashboard from 'views/admin/Dashboard';
import Ledger from 'views/admin/Ledger';

// Auth Imports
import Login from './views/auth/Login';

// Icon Imports
import {MdHome, MdLock} from 'react-icons/md';
import Logout from './views/auth/Logout';
import BankTransactions from './views/admin/BankTransactions';
import ActiveAccounts from './views/admin/ActiveAccounts';
import PendingCashfreeTransactions from './views/admin/PendingCashfreeTransactions';
import Ops from './views/admin/Ops';
import OpsApi from './views/admin/Ops/OpsApi';
import { AutomatedPayoutOps } from 'views/admin/Ops/AutomatedPayoutOps';
import EasySplitOps from 'views/admin/Ops/EasySplitOps';
import EasySplitOpsDetails from 'views/admin/Ops/EasySplitOpsDetails';

const routes = [
  {
    name: 'CashFlo Dashboard',
    layout: '/admin',
    path: 'default',
    icon: <MdHome className="h-6 w-6" />,
    component: <MainDashboard />,
  },
  {
    name: 'Ledger',
    layout: '/admin',
    path: 'ledger',
    icon: <MdHome className="h-6 w-6" />,
    component: <Ledger />,
  },
  {
    name: 'Bank Transactions',
    layout: '/admin',
    path: 'bank-transactions',
    icon: <MdHome className="h-6 w-6" />,
    component: <BankTransactions />,
  },
  {
    name: 'Active Accounts',
    layout: '/admin',
    path: 'active-accounts',
    icon: <MdHome className="h-6 w-6" />,
    component: <ActiveAccounts />,
  },
  {
    name: 'Pending Transactions',
    layout: '/admin',
    path: 'pending-cashfree-transactions',
    icon: <MdHome className="h-6 w-6" />,
    component: <PendingCashfreeTransactions />,
  },
  {
    name: 'Ops',
    layout: '/admin',
    path: 'ops',
    icon: <MdHome className="h-6 w-6" />,
    component: <Ops />,
  },
  {
    name: 'Ops Api',
    layout: '/admin',
    path: 'ops/:id',
    icon: <MdHome className="h-6 w-6" />,
    component: <OpsApi />,
  },
  {
    name: 'Payout Ops',
    layout: '/admin',
    path: 'ops/payout',
    icon: <MdHome className="h-6 w-6" />,
    component: <AutomatedPayoutOps />,
  },
  {
    name: 'Payout Ops easy split',
    layout: '/admin',
    path: 'ops/easysplit',
    icon: <MdHome className="h-6 w-6" />,
    component: <EasySplitOps />,
  },
  {
    name: 'Payout ops easy split details',
    layout: '/admin',
    path: 'ops/easysplit/:amount_collected_id',
    icon: <MdHome className="h-6 w-6" />,
    component: <EasySplitOpsDetails />,
  },
  {
    name: 'Sign In',
    layout: '/auth',
    path: 'login',
    icon: <MdLock className="h-6 w-6" />,
    component: <Login />,
  },
  {
    name: 'Sign Out',
    layout: '/auth',
    path: 'logout',
    icon: <MdLock className="h-6 w-6" />,
    component: <Logout />,
  },
];
export default routes;
